// Editable fields from the Operational Lookup API handoff.
const fields = [
    {
        "name": "stateId",
        "label": "State",
        "type": "lookup-select",
        "required": true,
        "source": "operational-states",
        "labelField": "stateName",
        "lockOnEdit": true
    },
    {
        "name": "stateName",
        "type": "hidden"
    },
    {
        "name": "code",
        "label": "Code",
        "type": "text",
        "required": true,
        "maxLength": 50
    },
    {
        "name": "name",
        "label": "Name",
        "type": "text",
        "required": true,
        "maxLength": 50
    }
];
export default fields;
